// extracted by mini-css-extract-plugin
export var container = "_a3-0";
export var icon = "_a3-1";
export var text = "_a3-2";